import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { BlankState, Button } from '@domain-group/suit-theme'

import useCurrentUser from '@hooks/useCurrentUser'

import BlankStateImage from '../../assets/no-tasks.svg'

interface TaskBlankStateProps {
  action: (user: any) => void,
}

const TaskBlankState = (props:TaskBlankStateProps) => {
  const { action: showBulkAssignUserTasksModal } = props

  const { currentUser } = useCurrentUser()

  return (
    <BlankState imageUrl={BlankStateImage}>
      <BlankState.Title>No Tasks</BlankState.Title>

      <BlankState.Paragraph>Try adjusting your filters or grab new tasks.</BlankState.Paragraph>

      <BlankState.Actions>
        <Button
          buttonStyle="secondaryEdit"
          icon={<FontAwesomeIcon icon={faPlus} />}
          onClick={() => showBulkAssignUserTasksModal({ user: currentUser })}
          size={['medium', 'small']}
          width={['100%', 'fit-content']}
        >
          Assign New Task
        </Button>
      </BlankState.Actions>
    </BlankState>
  )
}

export default TaskBlankState
